import React from "react";
import Utils from "Utils/utils";
import SparkleIcon from "Components/common/SparkleIcon";

const WandButton = ({ action = () => { } }) => {
  return (
    <div
      className="aiMagicWandBtn"
      onClick={e => {
        Utils.preventDefaultFn(e);
        action();
      }}
    >
      {/* The copilot's own mark: this button is now the way into the copilot,
          so it should not carry a different AI icon from the drawer, the ask
          bar and the sidebar. */}
      <SparkleIcon />
    </div>
  );
};

export default WandButton;
